/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Are the numbers truly random?`)
};

const es_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Son los números verdaderamente aleatorios?`)
};

const de_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind die Zahlen wirklich zufällig?`)
};

const nl_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zijn de getallen werkelijk willekeurig?`)
};

const fr_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les nombres sont-ils vraiment aléatoires ?`)
};

const it_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I numeri sono veramente casuali?`)
};

const pt_br2_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os números são verdadeiramente aleatórios?`)
};

const pt_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os números são verdadeiramente aleatórios?`)
};

const ja_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これらの番号は本当にランダムですか？`)
};

const zh_rg_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这些数字是真正随机的吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_faq1_q", locale)
	if (locale === "en") return en_rg_faq1_q(inputs)
	if (locale === "es") return es_rg_faq1_q(inputs)
	if (locale === "de") return de_rg_faq1_q(inputs)
	if (locale === "nl") return nl_rg_faq1_q(inputs)
	if (locale === "fr") return fr_rg_faq1_q(inputs)
	if (locale === "it") return it_rg_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_rg_faq1_q(inputs)
	if (locale === "pt") return pt_rg_faq1_q(inputs)
	if (locale === "ja") return ja_rg_faq1_q(inputs)
	return zh_rg_faq1_q(inputs)
};